/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import GenderModel from '../../../../models/GenderModel';
import InputWithLabel from '../../../components/InputWithLabel';

import ProfileModel from '../../../../models/ProfileModel';
import LocalizedGender from '../../presenters/LocalizedGender.redux';
import LocalizedBirthSex from '../../presenters/LocalizedBirthSex.redux';
import { ConnectedGrayPrivacyCard } from '../../../components/card/PrivacyCard';
import { ScrollAwareScroller } from '../../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../../components/appNav/AppHeaderScrollable';
import ContentWrapper from '../../../components/ContentWrapper';
import { PolicyName } from '../../../../models/PolicyModel';
import { Card, CardRowUI } from '../../../../bphComponents/bundle';
import COLORS from '../../../styles/Colors';

function allGenderKeys() {
  return ['list.gender.female', 'list.gender.male', 'list.gender.transgender-female', 'list.gender.transgender-male'];
}
const birthSexKeys = ['list.birth-sex.male', 'list.birth-sex.female', 'list.birth-sex.indeterminate'];

class ProfileGender extends React.Component {

  constructor(props) {
    super(props);

    this.handleChangeGender = this.handleChangeGender.bind(this);
    this.handleChangeOtherGender = this.handleChangeOtherGender.bind(this);

    this.state = {
      isBirthSexExpanded: false,
      isGenderExpanded: !props.profileData.gender_id,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.requestInitialData();
    const otherGenderText = _.get(this, 'props.profileData.other_gender', '');
    if (otherGenderText) return;

    this.props.onChange(_.assign({}, this.props.profileData, {
      other_gender: this.props.defaultOtherGenderText,
    }));
  }

  handleChangeGender(genderData) {
    const birthSex = this.props.isInitialSetup ? genderData.default_birth_sex_id : this.props.initialBirthSexId || genderData.default_birth_sex_id;
    const profileData = _.assign({}, this.props.profileData, {
      gender_id: genderData.id,
      birth_sex_id: birthSex,
    });

    if (!birthSex) {
      this.setState({ isBirthSexExpanded: true });
    }

    this.props.onChange(profileData);
  }

  handleChangeOtherGender(value) {
    const profileData = _.assign({}, this.props.profileData, {
      other_gender: value,
    });
    this.props.onChange(profileData);
  }

  handleChangeBirthSex = (birthSex) => {
    const birthSexId = birthSex.id;

    const profileData = _.assign({}, this.props.profileData, {
      birth_sex_id: birthSexId,
    });

    this.props.onChange(profileData);
  }

  render() {
    const { phraseData, profileData, genderIdMap, onWithdrawConsent, title } = this.props;
    const selectedGenderId = profileData.gender_id || null;
    const genderData = genderIdMap[selectedGenderId] || {};
    const currentGender = new GenderModel(genderData);
    const isOther = currentGender.isOther();
    const genderKeys = allGenderKeys();
    const otherGenderText = _.get(this, 'props.profileData.other_gender', '');
    const selectedBirthSexId = profileData.birth_sex_id || null;

    return (
      <ScrollAwareScroller>
        <AppHeaderScrollableText {...title} />

        <ContentWrapper>

          <ConnectedGrayPrivacyCard
            name={PolicyName.GENDER}
            subTitle="privacy.privacyBlock.gender.teaser"
            onWithdrawConsent={onWithdrawConsent}
          />

          <Card.CardShape>
            <Card.CollapsibleSummaryWithControl
              label={(
                <FormattedMessage {...phraseData.genderLabel} />
              )}
              background={COLORS.gsLightest}
              disableCollapseUntilValue={true}
              hasBottomBorder={this.state.isGenderExpanded}
              value={
                selectedGenderId
                ? (
                  <div className="font-color-profile-accent">
                    {
                      isOther
                      ? <FormattedMessage {...phraseData.identifyAnotherWayLabel} />
                      : <LocalizedGender profile={new ProfileModel(profileData)} />
                    }
                  </div>
                ) : null
              }
              isExpanded={this.state.isGenderExpanded}
              isMultiLine={false}
              onClick={() => {
                this.setState({
                  isGenderExpanded: !this.state.isGenderExpanded,
                });
              }}
            >
              {
                genderKeys.map((k, i) => {
                  const gender = this.props.genderMap[k] || {};
                  return (
                    <CardRowUI.SelectableRow
                      key={i}
                      isSelected={gender.id === selectedGenderId}
                      selectedClassName="fill-color-profile-highlight"
                      hasBottomBorder={true}
                      onClick={() => {
                        this.setState({ isGenderExpanded: false });
                        this.handleChangeGender(gender);
                      }}
                    >
                      <FormattedMessage id={`${k}.name`} />
                    </CardRowUI.SelectableRow>
                  );
                })
              }

              <CardRowUI.TextAction
                hasBottomBorder={true}
                onClick={() => {
                  this.setState({ isGenderExpanded: false });
                  this.handleChangeGender(this.props.genderMap['list.gender.other']);
                }}
              >
                <span className="font-subhead font-color-profile-accent">
                  <FormattedMessage {...this.props.phraseData.identifyAnotherWayLabel} />
                </span>
              </CardRowUI.TextAction>

            </Card.CollapsibleSummaryWithControl>

            {
              isOther && (
                <Card.CardContent>
                  <InputWithLabel
                    value={otherGenderText}
                    onChange={(e) => { this.handleChangeOtherGender(e.target.value); }}
                    label={<FormattedMessage {...this.props.phraseData.identifyAnotherWayLabel} />}
                    type="text"
                    name="other_gender"
                    initialFocus={false}
                    selectAllonFocus={true}
                    isClearable
                    clearValue={() => { this.handleChangeOtherGender(''); }}
                  />
                </Card.CardContent>
              )
            }
          </Card.CardShape>

          {
            selectedGenderId && (
              <Card.CardShape>
                <Card.CollapsibleSummaryWithControl
                  label={(
                    <FormattedMessage {...phraseData.birthSexLabel} />
                  )}
                  background={COLORS.gsLightest}
                  disableCollapseUntilValue={false}
                  hasBottomBorder={true}
                  value={
                    selectedBirthSexId
                    ? <div className="font-color-profile-accent"><LocalizedBirthSex profile={new ProfileModel(this.props.profileData)} /></div>
                    : null
                  }
                  isExpanded={this.state.isBirthSexExpanded}
                  isMultiLine={false}
                  onClick={() => {
                    this.setState({
                      isBirthSexExpanded: !this.state.isBirthSexExpanded,
                    });
                  }}
                >
                  {
                    birthSexKeys.map((k, i) => {
                      const birthSex = this.props.birthSexMap[k] || {};
                      return (
                        <CardRowUI.SelectableRow
                          key={i}
                          isSelected={birthSex.id === selectedBirthSexId}
                          selectedClassName="fill-color-profile-highlight"
                          hasBottomBorder={true}
                          onClick={() => {
                            this.setState({ isBirthSexExpanded: false });
                            this.handleChangeBirthSex(birthSex);
                          }}
                        >
                          <FormattedMessage id={`${k}.name`} />
                        </CardRowUI.SelectableRow>
                      );
                    })
                  }
                </Card.CollapsibleSummaryWithControl>
              </Card.CardShape>
            )
          }
        </ContentWrapper>
      </ScrollAwareScroller>
    );
  }
}
ProfileGender.propTypes = {
  title: PropTypes.object,
  phraseData: PropTypes.object,
  genderMap: PropTypes.object.isRequired,
  genderIdMap: PropTypes.object.isRequired,
  birthSexMap: PropTypes.object.isRequired,
  birthSexIdMap: PropTypes.object.isRequired,
  defaultOtherGenderText: PropTypes.string.isRequired,
  initialBirthSexId: PropTypes.number,
  profileData: PropTypes.object.isRequired,
  submitForm: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  requestInitialData: PropTypes.func.isRequired,
  submitErrorText: PropTypes.any,
  isInitialSetup: PropTypes.bool,
  onWithdrawConsent: PropTypes.func,
};

export default injectIntl(ProfileGender);
